var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "con-box",
    { attrs: { "show-header": false, "body-color": "#ffffff" } },
    [
      _c("div", { staticClass: "error-page" }, [
        _c("img", { attrs: { src: require("static/images/404.jpg") } }),
        _c("div", { staticClass: "error-page-tip" }, [
          _c("p", [_vm._v("Awww...Don’t Cry.")]),
          _c(
            "p",
            [
              _vm._v("It's just a "),
              _c("font", [_vm._v("404")]),
              _vm._v(" Error!")
            ],
            1
          ),
          _c("p", [
            _vm._v("What you're looking for may have been misplaced "),
            _c("br"),
            _vm._v("in Long Term Memory.")
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fd45664", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd45664","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/-404.vue
// module id = /CSF
// module chunks = 23